import React from "react";
import { NavLink } from "react-router-dom";
import "./AdminTabs.css";

const TABS = [
  { to: "/admin", label: "Admins", end: true },
  { to: "/admin/history", label: "History", end: false },
];

const AdminTabs = () => (
  <nav className="admin-tabs" aria-label="Admin sections">
    {TABS.map((tab) => (
      <NavLink
        key={tab.to}
        to={tab.to}
        end={tab.end}
        className={({ isActive }) =>
          `admin-tabs__tab${isActive ? " admin-tabs__tab--active" : ""}`
        }
      >
        {tab.label}
      </NavLink>
    ))}
  </nav>
);

export default AdminTabs;
